import React from 'react';
import classnames from 'classnames';
import { notification, Spin } from 'antd';
import { useIntl } from 'react-intl';

import Card from '../../components/Card';
import ResetPasswordForm from '../../components/ResetPasswordForm';
import useGetParams from '@src/packages/utils/hooks/useGetParams';
import ResetPasswordSuccessful from '../../components/ResetPasswordSuccessful';
import authStyles from '../authShared.module.less';
import styles from './styles.module.less';
import AuthService from '@src/services/AuthService';

export default function ResetPassword() {
  const [resetSuccessful, setResetSuccesful] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const params = useGetParams();
  const code = params.get('oobCode');
  const intl = useIntl();
  const authService = React.useMemo(() => new AuthService(), []);

  const onResetPassword = async password => {
    setLoading(true);
    try {
      await authService.resetPassword(code, password);
      setResetSuccesful(true);
    } catch (error) {
      const invalidCode =
        error.code === 'auth/expired-action-code' || error.code === 'auth/invalid-action-code';
      if (invalidCode) {
        notification.warning({
          message: intl.formatMessage({
            id: 'app.userAuth.expiredCode',
          }),
        });
      } else {
        notification.error({
          message: intl.formatMessage({
            id: 'app.userAuth.code.error',
          }),
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      className={classnames(
        authStyles.card,
        resetSuccessful && styles.resetPasswordCardSuccess,
      )}
    >
      <Spin spinning={loading} wrapperClassName={styles.spinInCard}>
        {!resetSuccessful ? (
          <ResetPasswordForm onSubmit={onResetPassword} />
        ) : (
          <ResetPasswordSuccessful />
        )}
      </Spin>
    </Card>
  );
}
